<script setup lang="ts">
export interface LiveMarketCellProps {
  value?: string;
  trend?: "default" | "up" | "down";
  type?: "default" | "percentage";
}

const props = defineProps<LiveMarketCellProps>();

const svgPlus = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16"><path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/></svg>`;
const svgMinus = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16"><path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/></svg>`;

const getChange = () => {
  if (props.value !== undefined) {
    return props.trend === "down"
      ? `${svgMinus}-${props.value.toString().replace("-", "")}`
      : `${svgPlus}+${props.value}`;
  }
  return "0.00%";
};
</script>

<template>
  <div
    :class="{
      up: props.trend === 'up',
      down: props.trend === 'down',
      'live-market-cell': true,
    }"
  >
    <span
      v-if="props.type === 'percentage'"
      :class="{
        'stock-plus': props.trend === 'up',
        'stock-minus': props.trend === 'down',
      }"
      v-html="getChange()"
    ></span>
    <span v-else v-html="props.value" />
  </div>
</template>
